import FW from '../fw/fw';


export default class GoogleCastHelpers {

  #rmp;
  #castTitle = 'Media';
  #castContentType = '';

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get castContentType() {
    return this.#castContentType;
  }

  get castTitle() {
    return this.#castTitle;
  }

  filterContentType() {
    if (this.#rmp.readingDashShaka) {
      this.#castContentType = 'application/dash+xml';
    } else if (this.#rmp.readingHls || this.#rmp.readingHlsJS || this.#rmp.readingHlsShaka) {
      this.#castContentType = 'application/vnd.apple.mpegurl';
    } else if (this.#rmp.readingMp4 && !this.#rmp.readingWebM) {
      this.#castContentType = 'video/mp4';
    } else if (this.#rmp.readingMp4 && this.#rmp.readingWebM) {
      this.#castContentType = 'video/webm';
    } else if (this.#rmp.audioOnly || this.#rmp.audioOnlyInVideoPlayer) {
      if (this.#rmp.readingM4a) {
        this.#castContentType = 'audio/mp4';
      } else if (this.#rmp.readingMp3) {
        this.#castContentType = 'audio/mp3';
      } else if (this.#rmp.readingOgg) {
        this.#castContentType = 'audio/ogg';
      }
    }
    this.#rmp.googleCastUrl = this.#rmp.startingSrcUri;
  }

  prepareLoadCastMedia() {
    this.#rmp.pauseRequestedByLoadCastMedia = true;
    this.#rmp.pause();
    const castMedia = window.chrome.cast.media;
    const mediaInfo = new castMedia.MediaInfo(
      this.#rmp.googleCastUrl,
      this.#rmp.rmpGoogleCastHelpers.castContentType
    );
    mediaInfo.metadata = new castMedia.GenericMediaMetadata();
    if (this.#rmp.contentMetadata.googleCastType === 'MOVIE' || this.#rmp.contentMetadata.googleCastType === 'TV_SHOW') {
      mediaInfo.metadata.metadataType = this.#rmp.contentMetadata.googleCastType;
    } else {
      mediaInfo.metadata.metadataType = castMedia.MetadataType.GENERIC;
    }
    if (this.#rmp.contentMetadata.title) {
      this.#castTitle = this.#rmp.contentMetadata.title;
    }
    mediaInfo.metadata.title = this.#castTitle;
    let googleCastPoster = this.#rmp.posterUri;
    if (this.#rmp.contentMetadata.poster.length > 0) {
      googleCastPoster = this.#rmp.contentMetadata.poster[this.#rmp.contentMetadata.poster.length - 1];
    }
    mediaInfo.metadata.images = [{
      url: googleCastPoster
    }];
    if (this.#rmp.contentMetadata.releaseDate !== '') {
      mediaInfo.metadata.subtitle = this.#rmp.contentMetadata.releaseDate;
    }
    mediaInfo.customData = {};
    if (this.#rmp.isVod) {
      mediaInfo.streamType = castMedia.StreamType.BUFFERED;
    } else {
      mediaInfo.streamType = castMedia.StreamType.LIVE;
      mediaInfo.customData.isLive = true;
    }
    if (this.#rmp.ads && this.#rmp.adTagUrl) {
      mediaInfo.customData.adTagUrl = this.#rmp.adTagUrl;
    }
    if (this.#rmp.googleCastAdTagUrl) {
      mediaInfo.customData.adTagUrl = this.#rmp.googleCastAdTagUrl;
    }
    if (mediaInfo.customData.adTagUrl && this.#rmp.googleCastDisableAds) {
      mediaInfo.customData.adTagUrl = '';
    }
    if (this.#rmp.googleCastVmapAdsRequest) {
      mediaInfo.customData.vmapAdsRequest = this.#rmp.googleCastVmapAdsRequest;
      mediaInfo.customData.adTagUrl = '';
    }
    // DRM
    if (!FW.isEmptyObject(this.#rmp.shakaDrm)) {
      if (this.#rmp.shakaDrm.servers) {
        if (this.#rmp.shakaDrm.servers['com.widevine.alpha']) {
          mediaInfo.customData.licenseUrl = this.#rmp.shakaDrm.servers['com.widevine.alpha'];
        }
      }
    }
    if (!FW.isEmptyObject(this.#rmp.shakaRequestConfiguration)) {
      if (this.#rmp.shakaRequestConfiguration.license) {
        if (this.#rmp.shakaRequestConfiguration.license.headers) {
          mediaInfo.customData.licenseHeaders = this.#rmp.shakaRequestConfiguration.license.headers;
        }
        if (typeof this.#rmp.shakaRequestConfiguration.license.credentials === 'boolean') {
          mediaInfo.customData.credentials = this.#rmp.shakaRequestConfiguration.license.credentials;
        }
      }
    }
    if (this.#rmp.googleCastDrmToday) {
      mediaInfo.customData.drmToday = this.#rmp.googleCastDrmToday;
    }

    return mediaInfo;

  }

}
